import { FILEHANDER } from 'js/mixin/fileType.js'
import * as Util from 'js/util/util.js'
import extend from 'extend'
/**
 * 大图模式和列表模式共有部分混入
 */
export default {
  mixins: [FILEHANDER], // 引用了getFolderType方法
  props: {
    // 当前列表item信息
    currentData: {
      type: Object,
    },
    // 当前列表展示模式
    isListMode: {
      type: Boolean,
    },
    // 索引号，标记唯一的值
    index: {
      type: Number,
      default: 0,
    },
    // 头部数据信息
    headerInfo: {
      type: Object,
      default: (value) => extend(value, {
        list: [], // 头部列表数据
        checkbox: true, // 显示checkbox
      }),
    },
    // 鼠标左键松开后，延长多久进入界面
    timerData: Object,
    // 鼠标在当前列的itemId
    hoverNeid: null,
    // 禁止鼠标点击
    isDisabled: Boolean,
    // 选中的文件
    selectFile: Object,
  },
  data() {
    return {
      showOperation: false, // 控制内嵌操作栏的显示隐藏,
    }
  },
  computed: {
    /**
         * 鼠标hover到列显示相应的按钮
         */
    isShowOperation() {
      if (this.hoverNeid && this.hoverNeid === this.currentData.neid) {
        return this.showOperation
      }
      return false
    },
    /** 文件不存在(预览模式默认一致为false) */
    noExist() {
      return false
    },
    /**
         * 判断显示该文件是否含有病毒
         */
    haveVirus() {
      return this.currentData.isvirus
    },
    /**
         * 显示图标组
         */
    isShowIconGroup() {
      if (this.currentData.data
                    && this.currentData.data[0]
                    && this.currentData.data[0].showIconGroup
      ) {
        return this.currentData.data[0].showIconGroup === 'show'
      }
      return true
    },
    /**
         * 选中的文件
         */
    selectedData() {
      return this.selectFile.data.map((item) => item.data)
    },
    /**
         * 显示层级遮罩(该功能暂时没有)
         */
    isShowMask() {
      return this.$cusMask.getMaskIsShow()
    },
  },
  filters: {
    /** 格式化文件名称 */
    filterHtml(value) {
      return value.replace(/(<mark>)|(<\/mark>)/g, '')
    },
  },
  methods: {
    /** 格式化文件名称 */
    formateName(val) {
      if (!val) return
      return val.indexOf('<mark>') > -1 ? val : val.replace(/&/g, '&amp;')
    },
    /**
         * 获取相应的icon图标
         */
    getIcon(item) {
      let icontype
      // 文件夹
      if (item.is_dir) {
        if (item.data && item.data[0] && item.data[0].icon) {
          icontype = `#${item.data[0].icon}`
        } else {
          icontype = `#${this.getFolderType(item)}`
        }
        // 如果存在icon图标直接取出来使用(这部分代码其实没有用，在外部的decorateData中并没有添加改类型，且为custom下的icon)
      } else if (item.data && item.data[0] && item.data[0].icon) {
        icontype = `#${item.data[0].icon}`
        // 根据文件类型截取
      } else {
        icontype = `#${Util.typeIcon(item.mime_type.split('.').pop())}`
      }
      // 判断文件是否被删除
      if (item.is_deleted) icontype = `${icontype}-delete`
      return icontype
    },
    /**
         * 鼠标左键按住松开后，触发的事件
         */
    clickHandler($event) {
      clearTimeout(this.timerData.timer)
      this.timerData.timer = setTimeout(() => {
        const target = $event.target || $event.srcElement
        const refs = this.$refs
        // --------------++++++dom点击事件对象+++++++++--------------------
        const { checkbox } = refs // 当前列的checkbox的dom对象
        const name = refs.name[0] // 当前列的文件名称dom对象
        // ------------++++++其他dom对象部分+++++++---------------------
        const fileicon = refs.fileicon && refs.fileicon[0] // 当前列的svg图标dom对象(文件夹图标，列表模式前面的图标)
        const { bigImg } = refs // 大图模式下图片对象
        const { bgicon } = refs // 大图模式下的图标对象
        const bgSvg = refs.bgsvg // 大图模式下的svg图标
        const { fileitem } = refs // 整列dom对象不包含checkbox(列)
        const { fileItem } = refs // 整列dom对象包含checkbox(大图)
        const filrArea = refs.filrArea[0] // 文件部分(图标，名称)
        const fileInfoSpan = refs.fileInfoSpan[0] // 文件部分
        const fileBgDisplay = refs.bgDisplay // 大图模式下，文件显示icon或图片的部分
        // --------------+++++++++其他文件数据信息+++++++++------------------
        const { index } = this // 当前列表id
        const { currentData } = this // 当前数据信息
        const { checked } = currentData // 当前数据选中状态
        if ($event.button == 0) { // 左键
          if ($event.ctrlKey && !this.isDisabled) { // 按住ctrl
            this.$emit('CtrlAndClick', { index, currentData })
          } else if ($event.shiftKey && !this.isDisabled) { // 按住shift
            this.$emit('ShiftAndClick', { index, currentData })
          } else if (checkbox === target || checkbox === target.parentNode) { // 如果点击的是checkbox
            this.$emit('CtrlAndClick', { index, currentData })
          } else if (name === target || target.parentNode === name) { // 点名字
            this.$emit('singleSelect', { index, currentData }) // 点时选中
            // 抛出item列表的点击事件
            this.$emit('itemClick', this.currentData)
          } else if (
            fileItem === target
                            || fileitem === target
                            || fileitem === target.parentNode
                            || fileicon === target
                            || bgicon === target
                            || bgSvg === target
                            || filrArea === target
                            || fileInfoSpan === target
                            || bigImg === target) {
            this.$emit('singleSelect', { index, currentData })
          } else if (fileBgDisplay && fileBgDisplay.contains(target) || target.toString() == '[object SVGElementInstance]') { // 兜底操作 P.S.在ie中点击svg时contains没作用，所以当target为svg时,直接选中
            this.$emit('singleSelect', { index, currentData })
          }
        } else if ($event.button == 2) { // 右键
          if (!checked) { // 没有选中设置为选中状态
            this.$emit('singleSelect', { index, currentData })
          }
          // 设置按钮的显示位置
          this.setPos($event)
        }
      }, this.timerData.timeStamp)
      // 触发鼠标经过事件
      this.mouseenterHandler()
    },
    /**
         * 双击操作
         */
    dblclickHandler($event) {
      // 出现操作菜单的时候不要双击
      if (this.isShowMask) return
      // 清空进入滞留事件
      clearTimeout(this.timerData.timer)
      // 如果该文件/文件夹禁止双击打开，则仅选中
      // if (this.currentData.disDouble) {
      //     this.$emit('singleNameSelect', {index: this.index, currentData: this.currentData});
      // }
      this.$emit('singleSelect', { index: this.index, currentData: this.currentData }) // 双击时选中
      this.$emit('itemClick', this.currentData)
    },
    /**
         * 设置右键要显示的列表位置
         */
    setPos(e) {
      this.$emit('setPosition', { left: e.pageX, top: e.pageY, isShow: true })
    },
  },
}
